import React from "react";
import CurrencyCard from "../GeneralCards/CurrencyCard";
import cashIcon from "../../../images/gameplay_ui/icons/cash_icon.svg";
import locoIcon from "../../../images/gameplay_ui/icons/loco_brigade_icon.svg";
import AddRemoveButtons from "../AddRemoveButtons";
import GameButtonWithText from "../GameButtonWithText";
import {GetBrigadeCost} from "../../../gameplay/model/Balance";
import GameData from "../../../gameplay/model/GameData";
import agent from "../../../agent";
import UtilsFunctions from "../../../utils/UtilsFunctions";
import x from "../../../images/icons/close_red.svg";

class BuyContractorsPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contractorsCount: 0
    }

    let HRIndex = UtilsFunctions.getRoleNameIndex("Зам. по кадрам и социальным вопросам")
    this.isHR = UtilsFunctions.playerHasRole(HRIndex);
  }

  componentDidMount() {
    this.setState({
      contractorsCount: 0
    });
  }

  addBrigades(diff) {
    this.setState({
      contractorsCount: diff
    });
  }

  buyContractors() {
    if (!this.isHR) {
      alert("Нанимать бригады может только Зам. по кадрам и социальным вопросам");
      return;
    }

    if (this.state.contractorsCount * GetBrigadeCost() <= GameData.CurrentGame.cash) {
      agent.GamePlay.buyContractors(this.props.teamID, {
        stationId: this.props.stationId,
        count: this.state.contractorsCount
      }, () => {
        this.props.onClose(this);
      });
    } else
      alert("Недостаточно средств для покупки");
  }

  render() {
    let bgStyle = {
      zIndex: "10",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
      width: "184px",
      height: "150px",
      padding: "5px",
      borderRadius: "3px",
      background: "#F2F2F2"
    }

    let posStyle = this.props.isRight ? {left: "10px"} : {right: "10px"};

    return <div style={{...bgStyle, ...posStyle}}>
      <CurrencyCard icon={locoIcon} value={"Подрядчики"} fontSize={14} textColor={"black"} size={20} style={{
        paddingTop: "5px"
      }}/>
      <img src={x} alt="X" className="x" onClick={() => {
        this.props.onClose(this)
      }}/>
      <CurrencyCard icon={cashIcon} value={3000000} fontSize={14} textColor={"black"} size={20} style={{
        paddingTop: "5px"
      }}/>
      <AddRemoveButtons
        asInputNumber={true}
        max={Math.floor(GameData.CurrentGame.cash / (GetBrigadeCost() * 3))}
        width={130}
        value={this.state.contractorsCount}
        onValueChanged={this.addBrigades.bind(this)}
        isCanBuy={this.isHR && (this.state.contractorsCount + 1) * GetBrigadeCost() <= GameData.CurrentGame.cash}
        isCanSell={this.isHR && this.state.contractorsCount > 0}
      />
      <GameButtonWithText width={164}
                          height={30}
                          colorStart={"#8CED00"}
                          colorEnd={"#66AE04"}
                          title={"КУПИТЬ"}
                          disabled={!this.isHR || this.state.contractorsCount === 0}
                          onClick={this.buyContractors.bind(this)}/>
    </div>
  }
}

export default BuyContractorsPopup;
